import { useOutlet } from 'react-router-dom';

/** Layout route shell; route sync runs via attachNewRelicRouteSync on the router instance. */
export function NewRelicRouteTracker() {
  return useOutlet();
}
